import { styled } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScBonanzaPromoSection = styled.div<{ showFullInfo?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .info {
    display: flex;
    flex-direction: column;
    ${typography['body1regular']}
    letter-spacing: 0.16px;

    span b {
      margin-right: 8px;
    }

    .level-info {
      display: flex;
      align-items: center;
      gap: 8px;

      .text {
        width: 100%;
        display: flex;
        flex-direction: column;
      }

      .unauth-text {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.16px;
        margin-right: 72px;
      }

      & > .addons {
        display: flex;
        align-items: center;

        @media (${device.mobileS}) {
          gap: 4px;
        }

        & > img {
          flex-shrink: 0;
        }

        & > i {
          flex-shrink: 0;
          transform: rotate(
            ${({ showFullInfo }) => (showFullInfo ? '-90deg' : '90deg')}
          );
          transition: color 0.3s ease;
          color: ${({ theme, showFullInfo }) =>
            showFullInfo ? theme.whiteColor : theme.blackLightColor};
        }
      }
    }
  }

  .loginBtn {
    min-width: 0;
  }
`;
